/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingConfigSnapshotResponseTaskGradeProjectorsAnyOf } from './gradingConfigSnapshotResponseTaskGradeProjectorsAnyOf';

export type GradingConfigSnapshotResponseTaskGradeProjectors =
  GradingConfigSnapshotResponseTaskGradeProjectorsAnyOf | null;
